var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmployeePrice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.125,
    cy: 8.5,
    r: 3,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 19C14.25 15.6173 11.5077 12.875 8.125 12.875C4.74226 12.875 2 15.6173 2 19",
    stroke: "white",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6051 11.3371H16.0562C16.2633 11.8886 16.5917 12.3192 17.0415 12.6289C17.4984 12.9386 17.9982 13.0935 18.5408 13.0935C19.6189 13.0935 20.3793 12.6478 20.822 11.7564H22C21.7144 12.4816 21.2682 13.0368 20.6613 13.4221C20.0616 13.8074 19.3583 14 18.5515 14C17.7519 14 17.0237 13.7583 16.3668 13.2748C15.7171 12.7913 15.2673 12.1454 15.0174 11.3371H14V10.5666H14.8568C14.8353 10.3853 14.8246 10.2002 14.8246 10.0113C14.8246 9.81492 14.8353 9.61851 14.8568 9.4221H14V8.66289H15.0174C15.2673 7.85458 15.7171 7.20869 16.3668 6.72521C17.0237 6.24174 17.7519 6 18.5515 6C19.3583 6 20.0616 6.19263 20.6613 6.5779C21.2682 6.96317 21.7144 7.51841 22 8.24363H20.822C20.3793 7.35977 19.6403 6.91785 18.6051 6.91785C18.0125 6.91785 17.4913 7.07271 17.0415 7.38244C16.5917 7.68461 16.2633 8.11143 16.0562 8.66289H18.6051V9.4221H15.8635C15.8349 9.58074 15.8206 9.77337 15.8206 10C15.8206 10.2191 15.8349 10.4079 15.8635 10.5666H18.6051V11.3371Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeePrice);
export default __webpack_public_path__ + "static/media/employee-price.bceec795ad258a3ba06e7fb36bc8583e.svg";
export { ForwardRef as ReactComponent };